module.exports = __webpack_public_path__ + "static/img/login-boy-pc.9a83d3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-boy-pc.png
// module id = /NFc
// module chunks = 1